export default "__VITE_ASSET__DVVwPDS3__"